<template>
    <div id="fixedNav">
        <ul>
            <li @click="goEvent(0)" :class="index == 1 ? `active` : ``">
                活动首页
            </li>
            <li @click="goEvent(1)" :class="index == 2 ? `active` : ``">
                预约有礼
            </li>
            <li @click="goEvent(2)" :class="index == 3 ? `active` : ``">
                成团礼包
            </li>
            <li @click="goEvent(3)" :class="index == 4 ? `active` : ``">
                成团抽奖
            </li>
            <li @click="goEvent(4)" :class="index == 5 ? `active` : ``">
                版本特色
            </li>
            <li @click="goEvent(5)" :class="index == 6 ? `active` : ``">
                新区福利
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const index = ref(1);
const tops = [0, 1083, 2392, 3475, 4705, 5609];

onMounted(() => {
    document.addEventListener("scroll", () => {
        const top = document.documentElement.scrollTop;
        if (top >= tops[0] && top < tops[1]) {
            index.value = 1;
        } else if (top >= tops[1] && top < tops[2]) {
            index.value = 2;
        } else if (top >= tops[2] && top < tops[3]) {
            index.value = 3;
        } else if (top >= tops[3] && top < tops[4]) {
            index.value = 4;
        } else if (top >= tops[4] && top < tops[5]) {
            index.value = 5;
        } else {
            index.value = 6;
        }
    });
});

const goEvent = (index) => {
    const top = tops[index] || 0;
    window.scrollTo({
        top,
        behavior: "smooth"
    });
};
</script>

<style lang="scss" scoped>
#fixedNav {
    position: fixed;
    z-index: 5;
    right: 0px;
    top: 45%;
    ul {
        li {
            width: 126px;
            height: 37px;
            line-height: 37px;
            text-align: right;
            box-sizing: border-box;
            padding-right: 16px;
            cursor: pointer;
            font-size: 16px;
            margin-bottom: 8px;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/fixed-nav-bg.png");
            background-repeat: no-repeat;
            color: #e3cc9c;
            &.active {
                color: #fff;
                background-position: 0px -48px;
            }
        }
    }
}
@media screen and (min-width: 1920px) {
    #fixedNav {
        right: 50%;
        margin-right: -960px;
    }
}
</style>
